<template>
  <ul class="price-details">
    <li class="overall bottom-small" :class="classes">
      <span class="price">
        <span v-if="showTitle">
          {{ $t('booking.show.prices.total_price') }}
        </span>
        {{ booking.price |currency }}
        {{ $t('_vat') }}
        <span v-if="showReminder">*</span>
      </span>
    </li>

    <li class="breakfast" :class="classes">
      <span v-if="breakfastIncluded">
        {{ $t('booking.show.prices.breakfast.included') }}
      </span>

      <span v-else>
        <span v-if="breakfastValue">
          {{ $t(
            'booking.show.prices.breakfast.excluded.inc',
            { price: $options.filters.currency(breakfastValue) }
          ) }}
        </span>

        <span v-else>
          {{ $t('booking.show.prices.breakfast.excluded.noValue') }}
        </span>
      </span>
    </li>

    <li v-if="booking.is_contingent && booking.is_etape">
      {{ $t('booking.show.prices.is_etape') }}
    </li>

    <li class="residence-tax" :class="classes" v-if="booking.residence_tax">
      {{ $t(
        'booking.show.prices.residence_tax',
        { price: $options.filters.currency(residenceTax) }
      ) }}
    </li>

    <li class="variable-tax" :class="classes" v-if="booking.variable_tax">
      {{ $t('booking.show.prices.variable_tax') }}
      {{ variableTax | percent }}
    </li>

    <li class="fees-global" :class="classes" v-if="displayFees.global">
      {{
        $t('booking.show.prices.feesGlobal', {
          label: booking.fees_global_label || $t('_booking_fees_global'),
          price: $options.filters.currency(booking.fees_global)
        })
      }}
    </li>

    <li class="fees-per-room" :class="classes" v-if="displayFees.perRoom">
      {{
        $t('booking.show.prices.feesPerRoom', {
          label: booking.fees_per_room_label || $t('_booking_fees_per_room'),
          price: $options.filters.currency(booking.fees_per_room)
        })
      }}
    </li>

    <li class="per-night" :class="classes" v-if="pricePerNight">
      {{ $t('online.booking.info.is') }}
      {{ pricePerNight |currency }}
      {{ $t('online.booking.info.per_night') }}
    </li>

    <li v-if="showReminder" :class="classes" :style="{fontSize: '0.8em'}">
      {{ $t('booking.show.prices.reminder') }}
    </li>
  </ul>
</template>

<script>
import { countNbNights } from "@/utils/helpers"

export default {
  props: {
    anonymous: {
      type: Boolean,
    },
    booking: {
      type: Object,
      required: true
    },
    showTitle: {
      type: Boolean,
      default: false
    },
    showReminder: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      currentPage: this.$route.name,
      isSummary: false,
      isOnline: false
    }
  },

  created () {
    this.isSummary = this.currentPage === 'booking_summary'
    this.isOnline = this.booking.is_online
  },

  computed: {
    breakfastIncluded () {
      return this.booking.breakfast_included
    },

    breakfastValue () {
      if (this.isOnline) {
        return this.booking.breakfast_price || 0
      } else {
        return (this.breakfastIncluded || !this.booking.breakfast_price)
          ? 0
          : this.booking.breakfast_price
      }
    },

    residenceTax () {
      return this.booking.residence_tax || 0
    },

    variableTax () {
      return this.booking.variable_tax || 0
    },

    nbNights () {
      let from = this.booking.arrival_date
      let to = this.booking.departure_date

      return from && to ? countNbNights(from, to) : 0
    },

    pricePerNight () {
      return this.nbNights > 1 ? this.booking.price / this.nbNights : null
    },

    classes () {
      return this.isSummary
        ? "col-9 offset-3 col-md-10 offset-md-2 text-left p-0"
        : " "
    },

    displayFees () {
      let cieStore = this.anonymous ? this.booking.company : this.$store.getters["security/company"];

      if (!cieStore.orderNumber) return false
      if (!cieStore.orderNumber.required || !cieStore.order_number_required) return false

      return {
        global: !!this.booking.fees_global,
        perRoom: !!this.booking.fees_per_room
      }
    }
  }
}
</script>
